export const createClassroom = /* GraphQL */ `
  mutation CreateClassroom($input: CreateClassroomInput!) {
    createClassroom(input: $input) {
      id
      sk
      schemaVersion
      workspaceId
      name
    }
  }
`;

export const createClassroomActivity = /* GraphQL */ `
  mutation CreateClassroomActivity($input: CreateClassroomActivityInput!) {
    createClassroomActivity(input: $input) {
      id
      sk
      schemaVersion
      workspaceId
    }
  }
`;

export const createClassroomUnit = /* GraphQL */ `
  mutation CreateClassroomUnit($input: CreateClassroomUnitInput!) {
    createClassroomUnit(input: $input) {
      id
      sk
      schemaVersion
      workspaceId
    }
  }
`;

export const updateClassroomUnit = /* GraphQL */ `
  mutation UpdateClassroomUnit($input: UpdateClassroomUnitInput!) {
    updateClassroomUnit(input: $input) {
      id
      sk
      schemaVersion
      workspaceId
    }
  }
`;

export const deleteClassroomUnit = /* GraphQL */ `
  mutation DeleteClassroomUnit($input: DeleteClassroomUnitInput!) {
    deleteClassroomUnit(input: $input) {
      id
      sk
      schemaVersion
      workspaceId
    }
  }
`;

export const updateClassroom = /* GraphQL */ `
  mutation UpdateClassroom($input: UpdateClassroomInput!) {
    updateClassroom(input: $input) {
      id
      sk
      schemaVersion
      workspaceId
      name
    }
  }
`;

export const updateClassroomActivity = /* GraphQL */ `
  mutation UpdateClassroomActivity($input: UpdateClassroomActivityInput!) {
    updateClassroomActivity(input: $input) {
      id
      sk
      schemaVersion
      workspaceId
    }
  }
`;

export const createUserClassroom = /* GraphQL */ `
  mutation CreateUserClassroom($input: GenericRelationshipInput!) {
    createUserClassroom(input: $input) {
      id
      sk
    }
  }
`;

export const createClassroomResource = /* GraphQL */ `
  mutation CreateClassroomResource(
    $input: CreateResourceInput!
    $authorizationContext: AuthorizationContextInput
  ) {
    createClassroomResource(
      input: $input
      authorizationContext: $authorizationContext
    ) {
      id
      sk
      schemaVersion
      workspaceId
    }
  }
`;

export const updateClassroomResource = /* GraphQL */ `
  mutation UpdateClassroomResource(
    $input: UpdateResourceInput!
    $authorizationContext: AuthorizationContextInput
  ) {
    updateClassroomResource(
      input: $input
      authorizationContext: $authorizationContext
    ) {
      id
      sk
      schemaVersion
      workspaceId
    }
  }
`;

export const deleteClassroomResource = /* GraphQL */ `
  mutation DeleteClassroomResource(
    $input: DeleteResourceInput!
    $authorizationContext: AuthorizationContextInput
  ) {
    deleteClassroomResource(
      input: $input
      authorizationContext: $authorizationContext
    ) {
      id
      sk
      schemaVersion
      workspaceId
    }
  }
`;

export const createStudent = /* GraphQL */ `
  mutation CreateStudent($input: CreateStudentInput!) {
    createStudent(input: $input) {
      id
      sk
      schemaVersion
      workspaceId
      firstName
      lastName
    }
  }
`;

export const deleteStudent = /* GraphQL */ `
  mutation DeleteStudent($input: DeleteStudentInput!) {
    deleteStudent(input: $input) {
      id
      sk
      schemaVersion
      workspaceId
      firstName
      lastName
    }
  }
`;

export const updateStudent = /* GraphQL */ `
  mutation UpdateStudent($input: UpdateStudentInput!) {
    updateStudent(input: $input) {
      id
      sk
      schemaVersion
      workspaceId
      firstName
      lastName
    }
  }
`;

export const listUserClassrooms = /* GraphQL */ `
  query ListUserClassrooms(
    $input: ListUserClassroomsInput
    $authorizationContext: AuthorizationContextInput
  ) {
    listUserClassrooms(
      input: $input
      authorizationContext: $authorizationContext
    ) {
      items {
        id
        sk
        schemaVersion
        workspaceId
        classroom {
          id
          sk
          name
          data
          sectionNumber
          studentCount
          createdAt
          updatedAt
          subject
          grade
          calendarId
          courseId
          course {
            id
            sk
            name
            unitIds {
              id
            }
            # units {
            #   unit {
            #     id
            #     sk
            #     name
            #   }
            # }
          }
          unitId
          units {
            id
            maturity
            unit {
              id
              sk
              name
            }
          }
          users {
            user {
              id
              firstName
              lastName
            }
          }
          tags {
            key
            value
            type
          }
          isArchived
          isDeleted
        }
        user {
          id
        }
      }
      nextToken
    }
  }
`;

export const listClassroomActivities = /* GraphQL */ `
  query ListClassroomActivities($input: ModelListInput!) {
    listClassroomActivities(input: $input) {
      items {
        id
        sk
        schemaVersion
        workspaceId
        createdAt
        classroom {
          id
          sk
          name
        }
        tags {
          key
          value
          type
        }
        unit {
          id
          sk
          name
        }
        examConfig {
          id
          sk
          name
          maturity
          createdAt
          schemaVersion
          resource {
            id
            sk
            name
            description
            schemaVersion
            questionIds
            tags {
              key
              value
              type
            }
          }
          tags {
            key
            value
            type
          }
        }
      }
      nextToken
    }
  }
`;

export const listClassroomStudents = /* GraphQL */ `
  query ListClassroomStudents($input: ModelListInput!) {
    listClassroomStudents(input: $input) {
      items {
        id
        sk
        schemaVersion
        workspaceId
        fullName
        firstName
        lastName
        studentId
        createdAt
        updatedAt
        isDeleted
        tags {
          key
          type
          value
        }
      }
      nextToken
    }
  }
`;

export const getAcademicCalendar = /* GraphQL */ `
  query GetAcademicCalendar(
    $input: ModelGetInput!
    $authorizationContext: AuthorizationContextInput
  ) {
    getAcademicCalendar(
      input: $input
      authorizationContext: $authorizationContext
    ) {
      id
      sk
      schemaVersion
      workspaceId
      maturity
      bankId
      visibility
      name
      startAt
      endAt
      isArchived
      isDeleted
      instructionWeekdays
      nonInstructionDates {
        type
        label
        startAt
        endAt
      }
      gradingPeriodLength
      gradingPeriods {
        label
        startAt
        endAt
      }
    }
  }
`;

export const listAcademicCalendars = /* GraphQL */ `
  query listAcademicCalendars(
    $input: ListResourcesByWorkspaceIdThenSkInput!
    $authorizationContext: AuthorizationContextInput
  ) {
    listAcademicCalendars(
      input: $input
      authorizationContext: $authorizationContext
    ) {
      items {
        id
        sk
        workspaceId
        schemaVersion
        name
        startAt
        endAt
        instructionWeekdays
        nonInstructionDates {
          type
          label
          startAt
          endAt
        }
        gradingPeriodLength
        gradingPeriods {
          label
          startAt
          endAt
        }
      }
      nextToken
    }
  }
`;

export const createAcademicCalendar = /* GraphQL */ `
  mutation CreateAcademicCalendar(
    $input: CreateAcademicCalendarInput!
    $authorizationContext: AuthorizationContextInput
  ) {
    createAcademicCalendar(
      input: $input
      authorizationContext: $authorizationContext
    ) {
      id
      sk
      schemaVersion
      workspaceId
      name
      startAt
      endAt
      instructionWeekdays
      nonInstructionDates {
        type
        label
        startAt
        endAt
      }
    }
  }
`;

export const updateAcademicCalendar = /* GraphQL */ `
  mutation UpdateAcademicCalendar(
    $input: UpdateAcademicCalendarInput!
    $authorizationContext: AuthorizationContextInput
  ) {
    updateAcademicCalendar(
      input: $input
      authorizationContext: $authorizationContext
    ) {
      id
      sk
      schemaVersion
      workspaceId
      name
      startAt
      endAt
      instructionWeekdays
      nonInstructionDates {
        type
        label
        startAt
        endAt
      }
    }
  }
`;

export const getCourseCalendar = /* GraphQL */ `
  query GetCourseCalendar(
    $input: ModelGetInput!
    $authorizationContext: AuthorizationContextInput
  ) {
    getCourseCalendar(
      input: $input
      authorizationContext: $authorizationContext
    ) {
      id
      sk
      schemaVersion
      workspaceId
      maturity
      bankId
      visibility
      name
      calendarId
      calendar {
        id
        sk
        workspaceId
        schemaVersion
        name
        startAt
        endAt
        instructionWeekdays
        isDeleted
        nonInstructionDates {
          type
          label
          startAt
          endAt
        }
        gradingPeriodLength
        gradingPeriods {
          label
          startAt
          endAt
        }
      }
      courseId
      course {
        id
        sk
        schemaVersion
        workspaceId
        name
      }
      units {
        id
        dates
      }
      additionalNonInstructionDates {
        type
        label
        startAt
        endAt
      }
      isDeleted
    }
  }
`;

export const listCourseCalendars = /* GraphQL */ `
  query ListCourseCalendars(
    $input: ListResourcesByWorkspaceIdThenSkInput!
    $authorizationContext: AuthorizationContextInput
  ) {
    listCourseCalendars(
      input: $input
      authorizationContext: $authorizationContext
    ) {
      items {
        id
        sk
        schemaVersion
        workspaceId
        name
        calendarId
        calendar {
          id
          sk
          workspaceId
          schemaVersion
          name
          startAt
          endAt
          instructionWeekdays
          nonInstructionDates {
            type
            label
            startAt
            endAt
          }
          gradingPeriodLength
          gradingPeriods {
            label
            startAt
            endAt
          }
        }
        courseId
        units {
          id
          dates
        }
        additionalNonInstructionDates {
          type
          label
          startAt
          endAt
        }
      }
      nextToken
    }
  }
`;

export const createCourseCalendar = /* GraphQL */ `
  mutation CreateCourseCalendar(
    $input: CreateCourseCalendarInput!
    $authorizationContext: AuthorizationContextInput
  ) {
    createCourseCalendar(
      input: $input
      authorizationContext: $authorizationContext
    ) {
      id
      sk
      schemaVersion
      workspaceId
      type

      name
      calendarId
      courseId
      units {
        id
        dates
      }

      additionalNonInstructionDates {
        type
        label
        startAt
        endAt
      }
    }
  }
`;

export const updateCourseCalendar = /* GraphQL */ `
  mutation UpdateCourseCalendar(
    $input: UpdateCourseCalendarInput!
    $authorizationContext: AuthorizationContextInput
  ) {
    updateCourseCalendar(
      input: $input
      authorizationContext: $authorizationContext
    ) {
      id
      sk
      schemaVersion
      workspaceId
    }
  }
`;

export const setDefaultWorkspaceCalendar = /* GraphQL */ `
  mutation SetDefaultWorkspaceCalendar(
    $input: SetDefaultWorkspaceCalendarInput!
    $authorizationContext: AuthorizationContextInput
  ) {
    setDefaultWorkspaceCalendar(
      input: $input
      authorizationContext: $authorizationContext
    ) {
      id
      sk
      tags {
        key
        value
        type
      }
    }
  }
`;

export const getClassroom = /* GraphQL */ `
  query GetClassroom(
    $input: ModelGetInput!
    $authorizationContext: AuthorizationContextInput
  ) {
    getClassroom(input: $input, authorizationContext: $authorizationContext) {
      id
      sk
      name
      schemaVersion
      workspaceId
      calendarId
      unitId
      sectionNumber
      room
      data
      isArchived
      isDeleted
      tags {
        key
        value
        type
      }
      unit {
        id
        sk
        name
        numberLabel
        data
        subject
        courseId
        objectives {
          id
          sk
          data
          objective {
            id
            sk
            abbreviation
            annotations {
              label
              content
            }
            content
            notes
            scope
            sequence
            tags {
              key
              type
              value
            }
          }
          tags {
            key
            type
            value
          }
        }
        vocabulariesIds {
          id
          sk
          tags {
            key
            type
            value
          }
        }
      }
      units {
        id
        sk
        maturity
        unit {
          id
          sk
          name
          numberLabel
          resourcesIds {
            id
          }
        }
      }
      courseId
      course {
        id
        sk
        schemaVersion
        workspaceId
        bankId
        name
        alignmentScopes
        description
        duration
        grade
        subject
        resourcesIds {
          id
        }
        unitIds {
          id
          sk
          tags {
            key
            value
          }
        }
      }
      creatorId
      creator {
        id
        firstName
        lastName
        avatarHash
      }
      createdAt
      data
    }
  }
`;

export const getCourseObjectives = /* GraphQL */ `
  query GetCourseObjectives(
    $input: ModelGetInput!
    $authorizationContext: AuthorizationContextInput
  ) {
    getCourse(input: $input, authorizationContext: $authorizationContext) {
      id
      sk
      schemaVersion
      workspaceId
      units {
        id
        sk
        unit {
          id
          sk
          objectives {
            id
            sk
            data
            objective {
              id
              sk
              type
              abbreviation
              annotations {
                label
                content
              }
              content
              notes
              scope
              sequence
              tags {
                key
                value
              }
            }
            tags {
              key
              value
            }
          }
        }
      }
    }
  }
`;

export const getStudent = /* GraphQL */ `
  query GetStudent($input: ModelGetInput!) {
    getStudent(input: $input) {
      id
      sk
      firstName
      fullName
      idProviderType
      idProviderUserId
      isDeleted
      isDisabled
      lastName
      photoURL
      studentId
    }
  }
`;

export const getClassroomUnit = /* GraphQL */ `
  query GetClassroomUnit(
    $input: ModelGetInput!
    $authorizationContext: AuthorizationContextInput
  ) {
    getClassroomUnit(
      input: $input
      authorizationContext: $authorizationContext
    ) {
      id
      sk
      maturity
      unit {
        id
        sk
      }
    }
  }
`;

export const getClassroomActivity = /* GraphQL */ `
  query GetClassroomActivity(
    $input: ModelGetInput!
    $authorizationContext: AuthorizationContextInput
  ) {
    getClassroomActivity(
      input: $input
      authorizationContext: $authorizationContext
    ) {
      id
      sk
      schemaVersion
      workspaceId
      classroom {
        id
        sk
        name
      }
      unit {
        id
        sk
        name
      }
      examConfig {
        id
        sk
        name
        resource {
          id
          sk
          name
          questionIds
        }
      }
    }
  }
`;
